import { KeyCodes } from '../constants/appConstants'
import Button from './buttons/Button'
import Spinner from './Spinner'
import sortBy from 'lodash/sortBy'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

function workspaceMatchesName(workspace, name) {
  return workspace.name.toLowerCase().indexOf(name.toLowerCase()) > -1
}

export default class WorkspaceSelector extends Component {
  static propTypes = {
    children: PropTypes.node,
    isFetching: PropTypes.bool.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onChangeSelectedWorkspace: PropTypes.func.isRequired,
    onLinkClick: PropTypes.func.isRequired,
    onSaveClick: PropTypes.func.isRequired,
    selectedWorkspaceName: PropTypes.string,
    workspaces: PropTypes.array.isRequired
  }

  constructor(props) {
    super(props)
    this.onKeyUp = this.onKeyUp.bind(this)
  }

  onKeyUp(e) {
    const { onSaveClick } = this.props
    if (e.which === KeyCodes.ENTER) {
      onSaveClick()
    }
  }

  renderWorkspace(workspace) {
    const { onChangeSelectedWorkspace, selectedWorkspaceName } = this.props

    if (!workspaceMatchesName(workspace, selectedWorkspaceName)) {
      return null
    }

    return (
      <li
        className="workspace-selector-li"
        onClick={() => onChangeSelectedWorkspace(workspace.name)}
        key={workspace.id}
      >
        {workspace.name}
      </li>
    )
  }

  renderPopup() {
    const {
      isFetching,
      onChangeSelectedWorkspace,
      onSaveClick,
      selectedWorkspaceName
    } = this.props

    let { workspaces } = this.props
    workspaces = sortBy(workspaces, workspace => workspace.name.toLowerCase())

    return (
      <div className="popup-box">
        <Spinner spinning={isFetching} />
        <div className="create-workspace">
          <input
            type="text"
            placeholder="Select or Create Workspace"
            value={selectedWorkspaceName}
            onChange={e => onChangeSelectedWorkspace(e.target.value)}
            onKeyUp={this.onKeyUp}
          />
          <Button className="add-workspace-button" onClick={onSaveClick}>
            {I18n.t('Add')}
          </Button>
        </div>
        <ul className="workspace-selector-ul">
          {workspaces.map(this.renderWorkspace, this)}
        </ul>
      </div>
    )
  }

  render() {
    const { children, isOpen, onLinkClick } = this.props

    return (
      <div
        className="workspace-selector-container"
        onClick={e => e.nativeEvent.stopImmediatePropagation()}
      >
        <span onClick={onLinkClick}>{children}</span>
        {isOpen && this.renderPopup()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/WorkspaceSelector.js